import { useSyncExternalStore } from "react";

const KEY = "failover-expanded-families";
const listeners = new Set<() => void>();
let current: ReadonlySet<string> = load();

function load(): ReadonlySet<string> {
  try {
    const raw = JSON.parse(localStorage.getItem(KEY) || "[]");
    return new Set(Array.isArray(raw) ? raw.filter((k): k is string => typeof k === "string") : []);
  } catch {
    return new Set();
  }
}

function save(next: ReadonlySet<string>): void {
  current = next;
  try {
    localStorage.setItem(KEY, JSON.stringify([...next]));
  } catch {
    /* storage blocked — the fold state still holds for this page */
  }
  for (const l of listeners) l();
}

/** Flip whether a family (keyed `pairingId/sessionId` of its parent) lists its quiet worktrees. */
export function toggleFamily(parentKey: string): void {
  const next = new Set(current);
  if (!next.delete(parentKey)) next.add(parentKey);
  save(next);
}

/**
 * useExpandedFamilies returns the families this browser has unfolded, shared by every list that folds them
 * and remembered across reloads.
 */
export function useExpandedFamilies(): ReadonlySet<string> {
  return useSyncExternalStore(
    (l) => {
      listeners.add(l);
      return () => listeners.delete(l);
    },
    () => current,
  );
}
